module.exports = __webpack_public_path__ + "static/pinnacle-logo-9df0d1d7849d152d3fea41c6b60bbe1d.png";